import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VProgressLinear,{attrs:{"indeterminate":"","color":"primary","active":_vm.show,"absolute":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }